import type { FaireProductEntity } from "../../entity_types/product";

export const p_e9h8jtznjy: FaireProductEntity = {
  token: "p_e9h8jtznjy",
  type: "product",
  name: "Mini Coffin Board Natural Crystal Pendant Halloween (Single)",
  brandToken: "b_pxpb5s3cxg",
  brandName: "Gemcohub",
  imageUrl:
    "https://cdn.faire.com/fastly/6646deac9e2cac93a45207cc0bc6b7472f9e2f1313e0ba419331b4de4de90c38.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/23c30a696a0398187665d39c5c938648939d2cd8074e16914377aaab7732722e.jpeg",
    "https://cdn.faire.com/fastly/5c9f82d320dfe3c6780460843688f8e88fd6e1c47d6798cdcb0a50433eafa480.jpeg",
    "https://cdn.faire.com/fastly/67106dadaa430d4c18bcf0b5fcc385bbc7a83039247c1b90cc484c08923377a6.jpeg",
    "https://cdn.faire.com/fastly/18bc232091ca52d147f06deb902c2087eada4b199cf98b9bef12e7b82186e1e3.jpeg",
    "https://cdn.faire.com/fastly/241c5d4978c2ff95cc3bbc7a1656d61780ba6e622d8725902ffa8fa6158bbdc0.jpeg",
    "https://cdn.faire.com/fastly/91a08f2aec22844d8dcf328277e6a1d768dc1ed176b3acdabb616077d5017ea6.jpeg",
    "https://cdn.faire.com/fastly/c03fad6598d922760bbbd8fbd73660358354da043e658ae24f261118f01228f9.jpeg",
    "https://cdn.faire.com/fastly/6d05f7d06a8d5ac16dceec61cdd0bc8c17e3f1cca4d828094d3b15ba29c67530.jpeg",
    "https://cdn.faire.com/fastly/e85aeab559c1b9daab1e5beabcca8b6226c5cee93bea7dab11527954389be023.jpeg",
    "https://cdn.faire.com/fastly/b70db4becd807578b51faaf9432338ce63856726171360e6bc45aec24a162343.jpeg",
    "https://cdn.faire.com/fastly/a1ef29a902ed7fee4e7afab77496a4be594ae6eeebcb8fc1eb1635bb5281d6a7.jpeg",
    "https://cdn.faire.com/fastly/27fc52bbd9038d4307bb59bde05b736297f77570277836b1eda432a485065cd5.jpeg",
    "https://cdn.faire.com/fastly/9455e923c7b6ebd08d2ccd44ef33d60d3bc9b6566588a3f19d6c6cecc8e2bdf4.jpeg",
    "https://cdn.faire.com/fastly/8e0c0b6516087484c5c899935c822f1a1b1937a7f0f9b5095387beb8ec1e9cfb.jpeg",
    "https://cdn.faire.com/fastly/9634b0b21f5a29135d1adeca719f9c79da5be99676359e08037f94963cd161db.jpeg",
    "https://cdn.faire.com/fastly/9666333fbc831eac9989df434d2003f67175ddcb39b9460fec8a9f6224dca506.jpeg",
    "https://cdn.faire.com/fastly/6e687a23b52df702dfa54d3a6b067c2e8e564ad7c1d7858b88e6d71966557cc4.jpeg",
    "https://cdn.faire.com/fastly/8c02e83186233b80470121e4f8705b611a6f09f3130bdb513c0b441372efd34c.jpeg",
    "https://cdn.faire.com/fastly/6e77b7a6875e23f8ccca56e53a7255c14ead368c4160838dec7d3c00679ee66c.jpeg",
    "https://cdn.faire.com/fastly/1c02699787354b5b867fb5246f7bb3b44fa21f294d5f93da0d7f24fc43aea6b7.jpeg",
    "https://cdn.faire.com/fastly/7f9fcd282cbb62ed4229ad47fd4a5c7d021fed84211700a03607cf05a2af078c.jpeg",
    "https://cdn.faire.com/fastly/88756260b1aaa0581cfa1cc47bb1b4853a967333b42be84a9dcb289ad7e26079.jpeg",
    "https://cdn.faire.com/fastly/4e9a5fb37d2252b7e7b22dbd5d234226d19afd7f19bc3da0a7d1b64d88ebf1ea.jpeg",
    "https://cdn.faire.com/fastly/db66a1b85717bab55116298be78319710b8ccbdf32d2b1e99c9e309e1af277a4.jpeg",
    "https://cdn.faire.com/fastly/1da7523ebac52cce82648cb658ad112e55b7c1edec6b2acabd33100283452262.jpeg",
    "https://cdn.faire.com/fastly/6e9107b94398b52c35c06d34d145611c124746fff2d1e78d9bad6ced8aee1591.jpeg",
    "https://cdn.faire.com/fastly/ce178ef4652043a748dfbae286f99c9b65b0393cf5f64248ce18405092f0bb74.jpeg",
    "https://cdn.faire.com/fastly/fba68bb2c2988e15b419383911237bf8e054de04808d097c2ac90b28ca0053fb.jpeg",
  ],
  priceDollars: 5.54,
  description:
    "-ID: GEM-KS-P2444\n-Stones: anthracite, Lapis lazuli, Pink Dongling, Indian agate, Red jasper, Green East Mausoleum, obsidian, topazite, Blue-grained stone, Rose stone, Dragonblood Stone, Golden swan, tiger-eye, Blue Dongling, Red East Mausoleum, Crazy agate, White crystal, White turquoise, Opal (synthetic), Gold sandstone (synthetic), labradorite, lilac, Spotted stone, Pink crystal, Amethyst\n-Weight(s): 8g\n-Size: 3.0*1.9cm\n-Quality: Excellent\n-Lead Free, Nickel Free",
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:21.305Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
